import { useMemo } from 'react';
import { useSelector } from 'react-redux';

import { i18nLocaleSelector } from 'ducks/i18n/selectors';
import { I18n } from '@utils/i18n';
import { useProductionConfig } from './useProductionConfig';

export function useEquipmentColumnTitle() {
  const i18nLocale = useSelector(i18nLocaleSelector);
  const productionConfig = useProductionConfig();

  const equipmentColumnTitle = useMemo(() => {
    const defaultTitle = I18n.t('equipment') as string;
    if (productionConfig) {
      return i18nLocale === 'es'
        ? productionConfig.equipmentNameEs || defaultTitle
        : productionConfig.equipmentNameEn || defaultTitle;
    }
    return defaultTitle;
  }, [i18nLocale, productionConfig]);

  return equipmentColumnTitle;
}

export default useEquipmentColumnTitle;
